import React, { useMemo, useState } from 'react';
import { DropDown } from '@/components/design-system/molecules/dropdown';

interface PaymentTypeOption {
  value: string;
  displayValue: string;
}

interface PaymentTypeDropdownProps {
  value: string;
  onChange: (value: string) => void;
  options: PaymentTypeOption[];
}

export const PaymentTypeDropdown: React.FC<PaymentTypeDropdownProps> = ({
  value,
  onChange,
  options,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredOptions = useMemo(() => {
    if (!searchQuery) return options;

    const query = searchQuery.toLowerCase();
    return options.filter((option) => option.displayValue.toLowerCase().includes(query));
  }, [options, searchQuery]);

  return (
    <div className="mb-4">
      <DropDown
        showLabel
        label="Payment type"
        placeholder="Select payment type"
        value={value ? options.find((opt) => opt.value === value) : null}
        onChange={(selected) => onChange(selected?.value || '')}
        {...(value && {
          displayValue: options.find((opt) => opt.value === value)?.displayValue,
        })}
        onTextInputChange={(event) => setSearchQuery(event.target.value)}
        className="z-[100]"
        required
      >
        <DropDown.DropDownOptions>
          {filteredOptions.map((option) => (
            <DropDown.DropDownOption key={option.value} value={option}>
              <DropDown.DropDownOptionDefaultContent>
                {option.displayValue}
              </DropDown.DropDownOptionDefaultContent>
            </DropDown.DropDownOption>
          ))}
        </DropDown.DropDownOptions>
      </DropDown>
    </div>
  );
};
